// src/pages/sales-order/tabs/HeaderTab.jsx
import React from "react";
import SectionGrid from "../component/SectionGrid";

export default function HeaderTab({
    fields,
    formData,
    errors,
    onChange,
    readOnly,
    getInputTypeForField,
    getValueForField,
}) {
    return (
        <SectionGrid
            fields={fields}
            formData={formData}
            errors={errors}
            onChange={onChange}
            readOnly={readOnly}
            idPrefix="header"
            getInputTypeForField={getInputTypeForField}
            getValueForField={getValueForField}
        />
    );
}
